import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { setupStore } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import axios from 'axios';
import { installPosGateway, installCatalogNotifier } from './api/pos';

// POS gateway — POS rejimində (Electron / REACT_APP_POS_MODE=on) POS-əməliyyat
// route-larını pos_local backend-inə yönləndirir. Cloud davranışı dəyişmir.
installPosGateway();

// POS kataloq bildirişçisi — admin (cloud) qiyməti/menyu statusunu dəyişəndə
// pos_local-a sync olan dəyişikliyi tutub işçiyə toast bildirişi göstərir və
// açıq menyunu reload-suz yeniləyir. Yalnız POS rejimində işləyir.
installCatalogNotifier();

// Qlobal Axios Interceptor — yalnız 401 (Unauthenticated) halında login-ə yönləndir.
// 403 (Forbidden) halları komponentlərin öz catch bloklarında idarə olunur (AccessDenied, DontActiveAcount və s.)
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // POS gateway (pos_local) mənbəli 401 cloud sessiyasını bitirməməlidir —
    // POS ayrı pos_token işlədir; xətanı POS komponenti öz catch-ində idarə edir.
    if (error.response && error.response.status === 401 && !error.isPosGateway) {
      const currentPath = window.location.pathname;
      const isAuthEndpoint = error.config?.url?.includes('/auth/');
      if (
        !isAuthEndpoint &&
        currentPath !== '/' &&
        !currentPath.includes('/login') &&
        !currentPath.includes('/admin-login') &&
        !currentPath.includes('/order-details')
      ) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

const store = setupStore();
const persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

reportWebVitals();


